export enum CalendarContentType {
  Reports = 'reports',
  TimeOffs = 'timeOffs',
  UserTimeOffs = 'userTimeOffs',
}
